import { Analytics, logEvent } from "firebase/analytics";
import { AnalyticsPort } from "./AnalyticsPort";
import { AnalyticsEventName } from "./ProductAnalytics";

export class FirebaseAnalyticsAdapter implements AnalyticsPort {
  constructor(private readonly analytics: Analytics) {}
  logEvent(eventName: AnalyticsEventName, params?: Record<string, unknown>) {
    logEvent(this.analytics, eventName as string, params);
  }
}
